import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    createCapsuleFail,
    createCapsuleSuccess,
    deleteCapsuleFail,
    deleteCapsuleSuccess,
    getCapsuleFail,
    getCapsuleSuccess,
    getCapsulesFail,
    getCapsulesRequest,
    getCapsulesSuccess,
    getDomainesFail,
    getDomainesSuccess,
    getThemesByDomaineFail,
    getThemesByDomaineSuccess,
    setCapsuleLoading,
    updateCapsuleFail,
    updateCapsuleSuccess,
} from "../actions/capsuleActions";

import { API_BASE_URL, deleteRequest, getRequest, postRequest, putRequest } from "../../../api";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

const getErrorMessage = (error, fallback) =>
    error?.response?.data?.message || error?.response?.data?.error || error?.message || fallback;

export const buildCapsuleFormData = (payload = {}) => {
    const fd = new FormData();
    fd.append("nom", payload.nom || "");
    fd.append("reference", payload.reference || "");
    fd.append("description", payload.description || "");
    fd.append("ajouterAuMooc", payload.ajouterAuMooc ? "true" : "false");
    fd.append("domaineId", payload.domaineId || "");
    fd.append("themeId", payload.themeId || "");
    if (payload.file) fd.append("file", payload.file);
    return fd;
};

export function* getCapsulesSaga() {
    const url = `${API_BASE_URL}/api/formations/capsules`;

    yield put(setCapsuleLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid: getUid(), token: getToken() });
        yield put(getCapsulesSuccess(resp?.data || []));
    } catch (error) {
        yield put(getCapsulesFail(getErrorMessage(error, "Erreur chargement capsules")));
    } finally {
        yield put(setCapsuleLoading(false));
    }
}

export function* getCapsuleSaga(action) {
    const id = action?.payload?.id;
    const url = `${API_BASE_URL}/api/formations/capsules/${id}`;

    yield put(setCapsuleLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid: getUid(), token: getToken() });
        yield put(getCapsuleSuccess(resp?.data || null));
    } catch (error) {
        yield put(getCapsuleFail(getErrorMessage(error, "Erreur chargement capsule")));
    } finally {
        yield put(setCapsuleLoading(false));
    }
}

export function* createCapsuleSaga(action) {
    const url = `${API_BASE_URL}/api/formations/capsules`;
    const payload = action?.payload || {};

    yield put(setCapsuleLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: buildCapsuleFormData(payload),
            uid: getUid(),
            token: getToken(),
        });

        yield put(createCapsuleSuccess(resp?.data));
        yield put(getCapsulesRequest());
        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Capsule ajoutée avec succès",
            timer: 1500,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = getErrorMessage(error, "Erreur ajout capsule");
        yield put(createCapsuleFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setCapsuleLoading(false));
    }
}

export function* updateCapsuleSaga(action) {
    const { id, payload } = action?.payload || {};
    const url = `${API_BASE_URL}/api/formations/capsules/${id}`;

    yield put(setCapsuleLoading(true));
    try {
        const resp = yield call(putRequest, {
            url,
            data: buildCapsuleFormData(payload),
            uid: getUid(),
            token: getToken(),
        });

        yield put(updateCapsuleSuccess(resp?.data));
        yield put(getCapsulesRequest());
        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Capsule modifiée avec succès",
            timer: 1500,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = getErrorMessage(error, "Erreur modification capsule");
        yield put(updateCapsuleFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setCapsuleLoading(false));
    }
}

export function* deleteCapsuleSaga(action) {
    const id = action?.payload?.id;
    const url = `${API_BASE_URL}/api/formations/capsules/${id}`;

    yield put(setCapsuleLoading(true));
    try {
        yield call(deleteRequest, { url, uid: getUid(), token: getToken() });
        yield put(deleteCapsuleSuccess(id));
        yield put(getCapsulesRequest());
        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Capsule supprimée avec succès",
            timer: 1500,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = getErrorMessage(error, "Erreur suppression capsule");
        yield put(deleteCapsuleFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setCapsuleLoading(false));
    }
}

export function* getDomainesSaga() {
    const url = `${API_BASE_URL}/api/formations/domaines`;

    try {
        const resp = yield call(getRequest, { url, uid: getUid(), token: getToken() });
        yield put(getDomainesSuccess(resp?.data || []));
    } catch (error) {
        yield put(getDomainesFail(getErrorMessage(error, "Erreur chargement domaines")));
    }
}

export function* getThemesByDomaineSaga(action) {
    const domaineId = action?.payload?.domaineId;

    if (!domaineId) {
        yield put(getThemesByDomaineSuccess([]));
        return;
    }

    const url = `${API_BASE_URL}/api/formations/themes/by-domaine/${domaineId}`;

    try {
        const resp = yield call(getRequest, { url, uid: getUid(), token: getToken() });
        yield put(getThemesByDomaineSuccess(resp?.data || []));
    } catch (error) {
        yield put(getThemesByDomaineFail(getErrorMessage(error, "Erreur chargement thèmes")));
    }
}
